import type { SortingState } from '@tanstack/react-table';
import type { DocumentTemplateListParams } from '../types/documentTemplates.types';

type SortParams = Pick<DocumentTemplateListParams, 'sort' | 'direction'>;

const SORTABLE_COLUMNS = new Set(['name', 'updated_at']);

/** Table sorting state to the browse endpoint's `sort` and `direction`. */
export function templateListSort(sorting: SortingState): SortParams {
  const [first] = sorting;
  if (!first || !SORTABLE_COLUMNS.has(first.id)) return {};
  return { sort: first.id as SortParams['sort'], direction: first.desc ? 'desc' : 'asc' };
}
